
const reactUtils = {
    formatNumber(num) {
        if (!num && typeof num !== 'number') {
            num = '';
        }
        return num
            .toString()
            .split(/(?=(?:\d{3})+(?:\.|$))/g)
            .join('.');
    },
}


export default reactUtils;